/** Empty state with watermarked Avida logo + helpful CTA. */
export default function EmptyState({ icon: Icon, title, hint, action, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="relative bg-white border border-[#15233B]/10 rounded-lg py-12 px-6 text-center overflow-hidden"
    >
      <img
        src="/brand/avida-logo.png"
        alt=""
        aria-hidden
        className="absolute right-4 bottom-4 h-24 w-auto opacity-[0.06] select-none pointer-events-none"
      />
      <div className="relative">
        {Icon && (
          <div className="mx-auto h-12 w-12 rounded-full bg-[#FFCB05]/15 grid place-items-center mb-3">
            <Icon className="h-6 w-6 text-[#15233B]" />
          </div>
        )}
        <h3 className="text-base font-extrabold tracking-tight text-[#15233B]">{title}</h3>
        {hint && <p className="text-sm text-[#15233B]/60 mt-1 max-w-md mx-auto">{hint}</p>}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}
